import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const meteorologico = createAsyncThunk(
    'meteorologico/getMeteorologico',
    async () => {
        try {
            const request = await axios.get("/api/sensor/getMeteorologico")
            return request.data
        } catch (error) {
            throw error
        }
    }
)
